import SuccessOverlay from 'components/SuccessOverlay';

import { usePaymentSuccessContext } from './context';

const Content = ({}) => {
  const { props } = usePaymentSuccessContext();

  return <SuccessOverlay {...props} />;
};

export default Content;
